import { IEmployeeSimple } from "Dashboard/domain/IEmployeeSimple";
import { IOption } from "Dashboard/domain/IOption";
import { hrService } from "Dashboard/scenes/HumanResources/services/hr.services";
import { forwardRef, useEffect, useState } from "react";
import Select, {
  MultiValue,
  components,
  GroupBase,
  ValueContainerProps
} from "react-select";

const EmployeeMultiSelect = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IOption[]>([]);
  const [value, setValue] = useState<IOption[]>([]);
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  useEffect(() => {
    async function getData() {
      const employees = await hrService.getAllEmployees();
      const loadedOptions = employees.map((employee) => ({
        label: employee.employeeName,
        value: employee.employeeId,
      }));
      setOptions(loadedOptions);
      setIsLoading(false);
    }

    try {
      if (props.options) {
        setOptions(props.options);
      } else {
        getData();
      }
    } catch (err) {
      console.log(err);
    }
  }, [props.options]);

  useEffect(() => {
    if (props.value && options.length > 0) {
      const selectedValues = calculateSelectedValues();
      setValue(selectedValues);

      let optionsCopy = options.slice();
      sortOptions(optionsCopy, props.value);
      if (optionsCopy.map(o => o.value).toString() !==
        options.map(o => o.value).toString()) {
        setOptions(optionsCopy);
      }
    } else {
      setValue([]);
    }
  }, [options, props.value]);

  const calculateSelectedValues = () => {
    return props.value.map((manager: IEmployeeSimple) => {
      const matchingOption = options.find(opt =>
        opt.value === manager.employeeId);
      return {
        value: manager.employeeId,
        label: matchingOption?.label || manager.name
      };
    });
  };

  const sortOptions = (options: IOption[], selectedManagers: IEmployeeSimple[]) => {
    const selectedValues = selectedManagers.map(option => option.employeeId);
    options.sort((a: IOption, b: IOption) => {
      if (selectedValues.includes(a.value) && !selectedValues.includes(b.value)) {
        return -1;
      }
      if (!selectedValues.includes(a.value) && selectedValues.includes(b.value)) {
        return 1;
      }
      return a.label.localeCompare(b.label);
    });
  };

  const handleChange = (newValue: MultiValue<IOption>) => {
    const currentValues = newValue ? newValue.map(v => ({
      value: v.value,
      label: v.label
    })) : [];
    setValue(currentValues);
    props.onChange(currentValues.map(v => v.value));
  };

  const CustomValueContainer = ({
    children,
    ...props
  }: ValueContainerProps<IOption, true, GroupBase<IOption>>) => {
    const [valueItems, input] =
      children as [React.ReactNode, React.ReactNode];
    let displayValue = valueItems;

    if (Array.isArray(valueItems) && valueItems.length > 1) {
      const remainingCount = valueItems.length - 1;
      displayValue = (
        <>
          {valueItems[0]}
          <div style={{ marginLeft: "3px" }}>
            + {remainingCount}
          </div>
        </>
      );
    };

    return (
      <components.ValueContainer {...props}>
        {displayValue}
        {input}
      </components.ValueContainer>
    );
  };

  return (
    <Select
      isClearable
      isMulti
      menuPosition="fixed"
      hideSelectedOptions={false}
      styles={props.customStyles}
      ref={ref}
      options={options}
      value={value}
      onChange={handleChange}
      placeholder={props.placeholder ?? ""}
      loadingMessage={() => "Učitavanje..."}
      noOptionsMessage={() => "Ne postoji"}
      menuIsOpen={menuIsOpen}
      onMenuOpen={() => setMenuIsOpen(true)}
      onMenuClose={() => setMenuIsOpen(false)}
      onBlur={() => setMenuIsOpen(false)}
      components={{ ValueContainer: CustomValueContainer }}
      isLoading={isLoading}
      {...{ error: props.error }}
    />
  );
});

export default EmployeeMultiSelect;
